import { Component, OnInit } from "@angular/core";
import { NotificationService } from "../../../core/services/notification.service";
import { MatDialog } from "@angular/material/dialog";
import { WhitelistDialogComponent } from "./whitelist-dialog/whitelist-dialog.component";
import { LocationsControllerService } from "../../../core/api/controllers/locations-controller.service";
import { ILocation } from "../../../shared/interfaces/ILocation";

@Component({
  selector: "app-whitelist",
  templateUrl: "./whitelist.component.html",
  styleUrls: ["./whitelist.component.scss"],
})
export class WhitelistComponent implements OnInit {
  locations: ILocation[] = [];
  isLoading = false;
  searchTerm = "";
  readonly skeletonRows = [0, 1, 2, 3];

  constructor(
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private locationsController: LocationsControllerService,
  ) {}

  ngOnInit(): void {
    this.getLocations();
  }

  get filteredLocations(): ILocation[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      return this.locations;
    }
    return this.locations.filter((location) =>
      [location.name, location.state?.name, location.country?.name]
        .filter(Boolean)
        .some((value) => value.toLowerCase().includes(term)),
    );
  }

  clearSearch(): void {
    this.searchTerm = "";
  }

  trackByLocationId(index: number, location: ILocation): string {
    return location.id;
  }

  regionLabel(location: ILocation): string {
    return [location.state?.name, location.country?.name]
      .filter(Boolean)
      .join(", ");
  }

  /** Stable per-location colour, matching the Locations tab. */
  tileTone(location: ILocation): number {
    const source = location.id || location.name || "";
    let hash = 0;
    for (let i = 0; i < source.length; i++) {
      hash = (hash + source.charCodeAt(i)) % 6;
    }
    return hash;
  }

  getLocations() {
    this.isLoading = true;
    this.locationsController.getAllLocations().subscribe(
      (response) => {
        this.locations = response.locations;
        this.locations = this.locations.map((location) => {
          return {
            ...location,
            ips: ["192.168.1.1", "172.192.15.13", "152.145.161.2"],
            collapsed: false,
          };
        });
        this.isLoading = false;
      },
      (error) => {
        this.notificationService.error(error);
        this.isLoading = false;
      },
    );
  }

  openWhitelistDialog(location: ILocation) {
    this.dialog.open(WhitelistDialogComponent, {
      data: {
        location,
      },
      width: "620px",
      maxWidth: "94vw",
      autoFocus: false,
      panelClass: "whitelist-dialog-panel",
    });
  }
}
